import script from "./LocalePicker.vue?vue&type=script&setup=true&lang=ts"
export * from "./LocalePicker.vue?vue&type=script&setup=true&lang=ts"

import "./LocalePicker.vue?vue&type=style&index=0&id=44330d76&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44330d76"]])

export default __exports__